<script>
  import ApplicationState from "../../../../Stores/applicationStates"
  import Items from "./components/items.svelte"
  import Footer from "../../../../Shared/footer.svelte"
  import Navbar from "../../../../Shared/Navbar/index.svelte"
  import Loader from "../../../../Shared/Slots/loader.svelte"
  import { push, querystring } from "svelte-spa-router"
  import { onMount } from "svelte"
  import axios from "axios"
  import notify from "../../../../Script/notify"
  import Table from "../../../../Shared/Table/table.svelte"
  import Filter from "../../../../Shared/filter.svelte"
  import { queryStringToJSON } from "../../../../Script/queryString"
  import { getRequest } from "../../../../Script/apiMethods"

  /**
   * @type {String} text displayed with the svg loader while loading
   */
  let loadingText = "Fetching List of File Design Templates&nbsp;"
  /**
   * @type {Boolean} for showing Loader while loading the list of file templates
   */
  let showLoading = true

  let limit
  let page
  let sort
  let sortBy
  let search = {
    searchParam: "name",
    searchvalue: "",
  }
  let startDate = null
  let endDate = null

  let fileCount

  let query
  let fileList = []
  // List page api -fetch all list of templates.
  onMount(async () => {
    try {
      query = queryStringToJSON($querystring)

      // $ApplicationState.fileListToggle = true
      // limit = query.limit ? query.limit : !$ApplicationState.fileListToggle ? 12 : 10

      $ApplicationState.fileListToggle = query && query.list == "false" ? false : true
      limit = query.limit ? query.limit : 10
      page = query.page ? query.page : 1
      sort = query.sort ? query.sort : -1
      sortBy = query.sortBy ? query.sortBy : "date"
      if (query.sdate) startDate = query.sdate
      if (query.edate) endDate = query.edate
      if (query.sname) search.searchvalue = query.sname
      // if (query.sin) search.searchParam ? query.sin : "name"
      await fetchTemplate()
    } catch (error) {
      const info = "PAGE: File template list\nEVENT: onMount"
      notify.danger(error, info)
    }
  })

  const fetchTemplate = async () => {
    try {
      showLoading = true
      const { count, templates } = await getRequest(`/api/swagger/v2/templates/files?limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}${search.searchvalue ? `&sin=${search.searchParam}&sname=${search.searchvalue}` : ``}${startDate ? `&sdate=${startDate}` : ``}${endDate ? `&edate=${endDate}` : ``}`, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      fileCount = count
      fileList = templates
      push(`/templates/file?limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}${search.searchvalue ? `&sin=${search.searchParam}&sname=${search.searchvalue}` : ``}${startDate ? `&sdate=${startDate}` : ``}${endDate ? `&edate=${endDate}` : ``}&list=${$ApplicationState.fileListToggle}`)
    } catch (error) {
      throw error
    } finally {
      showLoading = false
    }
  }

  const whileChangingEntries = async (e) => {
    try {
      if (e.detail.entries) limit = e.detail.entries
      if (e.detail.activePage) page = e.detail.activePage
      if (e.detail.sort) sort = e.detail.sort
      if (e.detail.sortBy) sortBy = e.detail.sortBy
      startDate = e.detail.filter.date.startDate ? e.detail.filter.date.startDate : ""
      endDate = e.detail.filter.date.endDate ? e.detail.filter.date.endDate : ""
      if (e.detail.filter.search.searchParam) {
        search.searchParam = e.detail.filter.search.searchParam
        search.searchvalue = e.detail.filter.search.searchvalue
      }
      await fetchTemplate()
    } catch (error) {
      const info = "PAGE: File template list\nEVENT: Error occurred during actions such as sorting by date/ name, changing display entries, changing date filter, searching by name, or navigating pages."
      notify.danger(error, info)
    }
  }

  const resetList = async () => {
    try {
      limit = !$ApplicationState.fileListToggle ? 12 : 10
      page = 1
      sort = 1
      sortBy = "date"
      search.searchvalue = ""
      startDate = null
      endDate = null
      await fetchTemplate()
    } catch (error) {
      const info = "PAGE: File template list\nEVENT: Error occurred while resetting filter."
      notify.danger(error, info)
    }
  }

  const handleFiletempList = async () => {
    try {
      limit = !$ApplicationState.fileListToggle ? 12 : 10
      await fetchTemplate()
    } catch (error) {
      const info = "PAGE: File template list\nEVENT: Error occurred while toggling list and card view."
      notify.danger(error, info)
    }
  }
</script>

<svelte:head>
  <title>File Design Templates</title>
</svelte:head>

<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] pb-24 dark:bg-bodyblack">
  <Navbar />

  {#if showLoading}
    <div class="flex min-h-[200px] items-center justify-center text-base text-gray-400">
      <Loader>
        <span class="flex">
          {@html loadingText}
        </span>
      </Loader>
    </div>
  {/if}
  <div class="px-6 pb-12 pt-3">
    <div class="relative mx-auto mt-8 h-full w-full max-w-[920px] rounded-md bg-[#f7f7f7] dark:bg-bodyblack">
      <!-- file Temp ListToggle Switch -->

      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div
        on:click={() => {
          push(`/templates/file/edit?id=000000000000000000000000`)
        }}
        class="absolute right-0 top-0 z-10 flex h-9 w-max min-w-[36px] cursor-pointer items-center justify-center rounded-md border border-transparent bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 focus:outline-none active:bg-blue-500"
      >
        <span>
          <i class="fa-solid fa-plus" />
        </span>
        <span class="hidden sm:block">&nbsp;Add File Design Template</span>
        <span class="block sm:hidden">&nbsp;Add</span>
      </div>

      <Table filetemplate={true} on:listTypeChanged={handleFiletempList} on:changeEntries={whileChangingEntries} entriesList={$ApplicationState.fileListToggle ? [10, 50, 100] : [12, 60, 120]} title={"File Design Templates"} filterComponent={Filter} jsonData={fileList} count={fileCount} filter={true} on:resetEntries={resetList}>
        {#if fileList.length}
          <div class={$ApplicationState.fileListToggle ? "w-full space-y-3" : "w-full space-y-3 md:grid md:grid-cols-4 md:gap-3 md:space-y-0"}>
            {#each fileList as template}
              <div class={$ApplicationState.fileListToggle ? "w-full" : "md:col-span-1"}>
                <Items
                  on:fetchList={async () => {
                    try {
                      await fetchTemplate()
                    } catch (error) {
                      const info = "PAGE: File template list\nEVENT: Error occurred while fetching file template list again after deletion/ duplication of file template."
                      notify.danger(error, info)
                    }
                  }}
                  {template}
                  bind:showLoading
                  bind:loadingText
                  count={fileCount}
                />
              </div>
            {/each}
          </div>
        {:else}
          <div class="text-secondary2 select-none rounded-md bg-white py-6 text-center text-2xl dark:bg-darkgray dark:text-white">There is no file template</div>
        {/if}
      </Table>
    </div>
  </div>
  <Footer />
</div>
